import type { CollectionFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Collection,
  MutationCreateCollectionArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  type UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getCollectionsKey } from '../../utils/keys/collection.key.js'

export const useCreateCollection = (options?: {
  fields?: CollectionFields
  useMutationOptions?: UseMutationOptions<
    Collection,
    ClientError,
    MutationCreateCollectionArgs,
    { snapshot: Collection }
  >
}) => {
  const { useMutationOptions, fields } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  const collectionsKey = getCollectionsKey()

  return useMutation<
    Collection,
    ClientError,
    MutationCreateCollectionArgs,
    { snapshot: Collection }
  >(
    (input: MutationCreateCollectionArgs) =>
      client.collections.create(input, fields),
    {
      onSuccess: async _ => {
        queryClient.invalidateQueries(collectionsKey)
      },
      ...useMutationOptions,
    },
  )
}
